import { Product } from './product_model';
export class Cart{
    public totalItem:Number;
    public totalAmount:Number;
    public cartItemIds:any;
	constructor(){
    }
}
export const cart_params: Cart = {
	"totalItem": null,
	"totalAmount": null,
	"cartItemIds": []
}